


import './info.css'
function Info(){
 return(
    <div className="container">
  <h1>Info</h1>
    </div>
  )
}

export default Info;